import { Surface, Colors } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const SectionItemContainer = styled(Surface)`
  width: 100%;
  display: block;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 4px;
`

export const EditIcon = styled(FontAwesomeIcon)`
  color: ${Colors.primary};
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;

  &:active {
    transform: scale(0.8);
    opacity: 0;
  }
`

export const Title = styled.h3`
  color: ${Colors.secondary};
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 28px */
  margin: 0;
`

export const OptionalTitle = styled.h3`
  color: ${Colors.primary};
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 28px */
  margin: 0;
  margin-left: 5px;
`

export const DescriptionTitle = styled.span`
  color: ${Colors.secondary};
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin-left: 5px;
`

export const ShowFullDescriptionLink = styled.a`
  color: ${Colors.primary};
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 14.4px */
  letter-spacing: 0.48px;
  cursor: pointer;
  text-decoration: none;
  margin-top: 2px;
  margin-left: 10px;

  &:hover {
    text-decoration: underline;
  }
`
